import {authCoreClient} from "@utils/api/base";

// eslint-disable-next-line
export const UserSettings = {
  get: (token, settingType, config) => authCoreClient(token).get(`/settings/user/${settingType}`, config),
  update: (token, settingType, data) => authCoreClient(token).post(`/settings/user/${settingType}/update`, data),
};